import { axios } from '../../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom'
import styles from './subscribe_confirm.module.css';
import { getAxiosConfig } from '../../utils/apiUtils';
import { getLoggedInUser, updateUser } from '../../utils/authUtils'
import queryString from 'query-string'
import creditCard from '../../assets/images/credit-card.svg';
import successIcon from '../../assets/images/success-icon.svg';
import { Alert, Modal, Container, Row, Col } from 'react-bootstrap';
import { reportEvent } from '../../utils/analyticsUtils';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useTranslation } from 'react-i18next';

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}

const SubscribeConfirm = () => {
  const { t, i18n } = useTranslation();
  const [customer, setCustomer] = useState();
  const [coupon, setCoupon] = useState();
  const [couponData, setCouponData] = useState([]);
  const [goToSuccess, setGoToSuccess] = useState();

  const [noCreditCard, setNoCreditCard] = useState();
  const [subscriptionError, setSubscriptionError] = useState();
  const [disableSubscriptionButton, setDisableSubscriptionButton] = useState(false);

  const sendDataToGTM = useGTMDispatch();

  const { search } = useLocation()
  const values = queryString.parse(search)
  const {success} = values;

  const refreshCustomer = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/customer/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((customerResponse) => {
        setCustomer(customerResponse.data);
      })
      .catch((customerError) => {
        console.debug(customerError);
      });
  };

  const handleCreditCard = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/creditcard`,
      {},
      getAxiosConfig(),
    )
    .then((creditCardResponse) => {
      window.location.replace(`${creditCardResponse.data.redirectTo}?token=${creditCardResponse.data.token}`)
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleSubscription = (paymentPeriod) => {
    setDisableSubscriptionButton(true);

    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/subscription/new`,
      {
        couponId: coupon && coupon !== '' ? coupon : undefined,
        paymentPeriod,
      },
      getAxiosConfig(),
    )
    .then((subscriptionResponse) => {
      updateUser({
        user: subscriptionResponse.data.user
      });
      sendDataToGTM({event: '07Funnel_SubscriptionSuccesful', value: ''})
      reportEvent('07Funnel_SubscriptionSuccesful', {});
      setGoToSuccess(true);
    })
    .catch((subscriptionError) => {
      console.debug(subscriptionError);
      if(subscriptionError.response && subscriptionError.response.data.message === "No credit card"){
        setNoCreditCard(true);
      }else{
        setSubscriptionError(true);
      }
      setDisableSubscriptionButton(false);
    });
  }

  useEffect(
    () => {
      refreshCustomer();
      reportEvent('06Funnel_SubscriptionStart', {});
    },
    []
  );

  const debouncedUpdate = debounce(function updateCouponData() {
    console.debug("Test!")
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/coupon/search?name=${coupon}`,
      getAxiosConfig(),
    ).then((couponData) => {
      setCouponData(couponData.data);
    }).catch(() => {
      setCouponData([]);
    });
  }, 1000);

  useEffect(
    () => {
      debouncedUpdate();
    },
    [
      coupon,
    ]
  );

  console.debug(coupon);

  if (goToSuccess) {
    return <Redirect to="/account/subscribe/success" push/>;
  }

  return (
    <div class="container"
      style={{paddingLeft: 32}}
    >
      <div class="row py-5">
        <div class="breadcrumb1 col-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Home</a></li>
              <li className="breadcrumb-item"><a href="#">Mi cuenta</a></li>
              <li className="breadcrumb-item active" aria-current="page">Confirmación de subscripción</li>
            </ol>
          </nav>
        </div>
        <div class="row" style={{
          width: '100%'
        }}>
          <div class="col-md-12">
            <h2>Suscríbete a Chungungo</h2>

            {noCreditCard &&
              <Alert
                variant="danger"
              >
                Para suscribirte necesitas una tarjeta de crédito
              </Alert>
            }

            {subscriptionError &&
              <Alert
                variant="danger"
              >
                Error al tratar de suscribirte, inténtalo nuevamente y comprueba que tu tarjeta de crédito es válida
              </Alert>
            }

            <Modal
              show={disableSubscriptionButton}
            >
              <div class="modal-content">
                <div class="modal-body">
                  <h5 class="modal-title mb-3" style={{ color: '#692700' }}>Suscribiéndote a chungungo</h5>
                  <p>Espera un momento mientras revisamos que todo esté en orden...</p>
                </div>
              </div>
            </Modal>


            {/* Nueva organización ROW PAYMENT */}
            <Container>
              <Row> {/**Añade tu tarjeta */}
                <Col>
                  <h5 class="mt-4">Paso 1 - Añade una tarjeta de crédito</h5>
                  {(!customer || !customer.creditCardType) &&
                    <>
                      <p>Debes añadir una tarjeta de crédito válida para continuar. Podrás cambiarla después cada vez que quieras. Te redirigiremos a la plataforma segura Flow para que almacene el número de tu tarjeta y procese los pagos mes a mes. </p>
                      <a href="#" class="btn btn-primary" onClick={() => handleCreditCard()}>Añadir tarjeta</a>
                    </>
                  }

                  {customer && customer.creditCardType &&
                    <div class="d-flex justify-content-start my-3">
                      <div>
                        <img src={creditCard} alt="" />
                      </div>
                      <div class="ml-4">
                        <span class="cardNumber"> **** **** **** {customer.last4CardDigits}</span>
                        <div class="d-flex justify-content-between fw-bold">
                          <small class="text-muted">{customer.creditCardType.toUpperCase()}</small>
                        </div>
                      </div>
                    </div>
                  }

                  {success === '1' &&
                    <div
                      className="alert alert-success mt-4"
                      style={{
                        borderColor: '#00A184',
                        background: 'rgba(0, 161, 132, 0.15)',
                        color: '#00A184'
                      }}
                      role="alert"
                    >
                      <img class="mr-1" src={successIcon} alt="Éxito" width="24" />  ¡Tarjeta añadida exitósamente!
                    </div>
                  }
                </Col>
              </Row>

              <Row> {/**Selecciona tu suscripción */}
                <Col>
                <h5 class="mt-4">Paso 2 - Selecciona tu suscripción</h5>
                </Col>
              </Row>

              <Row> {/**tipos de suscripción 1 */}
                <Col lg={6} md={12} className="mt-4"> {/** SUSCRIPCIÓN 1 MENSUAL */}
                  <div className={`${styles.tipoSuscripcion} card card-body`}>

                    <div className="d-lg-flex justify-content-between align-items-lg-center"> {/*1*/}

                      <div className="pr-lg-4">
                        <p className="font-weight-bold">{t('subscription.subscribeconfirm_monthly.title')}</p>
                        <p className="small">
                        {t('subscription.subscribeconfirm_monthly.message')}
                        </p>
                      </div>

                      <div className="mt-4 mt-lg-0">
                        <p className={`${styles.suscripcionActual} m-0`}>{t('subscription.subscribeconfirm_monthly.price')}</p>
                        <p className="font-weight-bold text-muted text-lg-right">mensual</p>
                      </div>

                    </div> {/*1*/}

                    <div className="mt-4"> {/*2*/}

                      <p className="mb-2"><strong>¿Tienes código de descuento?</strong></p>
                      <form action="javascript:void(0)">

                        <div className="form-row">{/*T*/}

                          <div className="col-sm-9">
                            <input type="text" className="form-control mb-2 mr-sm-2" placeholder="Si tienes un cupón de descuento ponlo aquí" value={coupon} onChange={(event) => setCoupon(event.target.value)}/>
                          </div>

                          <div class="col-sm-3">
                            <button type="submit" className="btn btn-primary mb-2 btn-block" onClick={() => handleSubscription("monthly")} disabled={disableSubscriptionButton}>Suscribirme</button>
                          </div>

                        </div> {/*T*/}

                      </form>

                      {couponData && couponData[0] &&
                        <p style={{
                          color: 'green'
                        }}>
                          Descuento de {couponData[0].percent_off ? `${Math.floor(couponData[0].percent_off)}%` : `${couponData[0].currency} ${Math.floor(couponData[0].amount)}`} en tu suscripción mensual
                          {couponData[0].duration === 'Definite' ? ` por ${couponData[0].times} ${couponData[0].times > 1 ? 'meses' : 'mes'}` : ' para siempre'}
                        </p>
                      }
                    </div> {/*2*/}

                    </div> {/* fin 0 SUSCRIPCIÓN 1 MENSUAL */}
                </Col>
                <Col lg={6} md={12} className="mt-4"> {/** suscripción 3 */}
                  {/* 0 SEMESTRAL */}
                  <div className={`${styles.tipoSuscripcion} card card-body`}>

                    <div className="d-lg-flex justify-content-between align-items-lg-center"> {/*1*/}

                      <div className="pr-lg-4">
                        <p className="font-weight-bold">{t('subscription.subscribeconfirm_biannual.title')}</p>
                        <p className="small">
                        {t('subscription.subscribeconfirm_biannual.message')}
                        <br/>
                        <br/>
                        </p>
                      </div>

                      <div className="mt-4 mt-lg-0">
                        <p className={`${styles.suscripcionActual} m-0`}>{t('subscription.subscribeconfirm_biannual.price')}</p>
                        <p className="font-weight-bold text-muted text-lg-right">semestral</p>
                      </div>

                    </div> {/*1*/}

                    <div className="mt-4"> {/*2*/}
                      <p className="mb-2"><br/></p>
                      <form action="javascript:void(0)">

                        <div className="form-row">{/*T*/}
                          <div class="col-sm-3">
                            <button type="submit" className="btn btn-primary mb-2 btn-block" onClick={() => handleSubscription("biannual")}>Suscribirme</button>
                          </div>

                        </div> {/*T*/}

                      </form>
                    </div> {/*2*/}

                  </div> {/* 0 FIN SEMESTRAL */}
                </Col>
              </Row>
              
              <Row> {/**tipos de suscripción 2 */}

                <Col lg={6} md={12} className="mt-4">{/** suscripción 4 */}
                  {/* 0 ANUAL */}
                  <div className={`${styles.tipoSuscripcion} card card-body`}>

                    <div className="d-lg-flex justify-content-between align-items-lg-center"> {/*1*/}

                      <div className="pr-lg-4">
                        <p className="font-weight-bold">{t('subscription.subscribeconfirm_annual.title')}</p>
                        <p className="small">
                        {t('subscription.subscribeconfirm_annual.message')}
                        </p>
                      </div>

                      <div className="mt-4 mt-lg-0">
                        <p className={`${styles.suscripcionActual} m-0`}>{t('subscription.subscribeconfirm_annual.price')}</p>
                        <p className="font-weight-bold text-muted text-lg-right">anual</p>
                      </div>

                    </div> {/*1*/}

                    <div className="mt-4"> {/*2*/}
                      <p className="mb-2"><br/></p>
                      <form action="javascript:void(0)">

                        <div className="form-row">{/*T*/}
                          <div class="col-sm-3">
                            <button type="submit" className="btn btn-primary mb-2 btn-block" onClick={() => handleSubscription("annual")}>Suscribirme</button>
                          </div>

                        </div> {/*T*/}

                      </form>
                    </div> {/*2*/}

                    </div> {/* 0 FIN ANUAL */}
                </Col> {/**fin suscripción 4 */}
              </Row>
            </Container>

          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscribeConfirm;